exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.surface-list[data-v-30af8527] {\n    margin: 10px 10px 20px;\n}\n.surface-list-button[data-v-30af8527] {\n    font-size: 24px;\n    color: #fff;\n    font-weight: bold;\n    margin: 5px;\n}\n.surface-list-button-remove[data-v-30af8527] {\n    top: -28px;\n    right: -10px;\n}\n", ""]);

// exports
